// extracted by mini-css-extract-plugin
export default {"jumpWiggle":"JumpWiggle-module__jumpWiggle__cbImQwC","copilotRun":"JumpWiggle-module__copilotRun__ZwFg0NX"};